/**
 * ユーザーページ専用i18n定数
 */

export const USER_LIST_I18N = {
  // フィルター
  filter: {
    namePlaceholder: $localize`:@@adminSection.userList.placeholder.nameFilter:氏名 フィルター`,
  },

  // ステータス
  status: {
    active: $localize`:@@admin.userList.status.active:有効`,
    inactive: $localize`:@@admin.userList.status.inactive:無効`,
    available: $localize`:@@admin.userList.status.available:利用可能`,
  },

  // ユーザー名
  userName: {
    anonymous: $localize`:@@admin.userList.userName.anonymous:匿名計測者`,
  },

  // ダイアログ
  dialog: {
    title: $localize`:@@admin.userList.dialog.title:ダイアログ確認`,
    message: $localize`:@@admin.userList.dialog.message:ダイアログが表示されます`,
  },

  // ボタン
  button: {
    close: $localize`:@@admin.userList.button.close:閉じる`,
  },

  // メッセージ
  message: {
    removeContributorError: $localize`:@@admin.userList.message.removeContributorError:多職種スタッフの削除に失敗しました。再度お試しください。`,
    cancelInviteError: $localize`:@@admin.userList.message.cancelInviteError:招待のキャンセルに失敗しました。再度お試しください。`,
  },
} as const;

export type UserListI18n = typeof USER_LIST_I18N;
